import mapPartnerTagToGA from './mapPartnerTagToGA';
function partnerResourceHelper(partnerResource) {
  const headline = partnerResource?.title ?? 'good-drivers-save-more';
  const adSubHead = (partnerResource?.link?.label || '').replace(/[^a-zA-Z ]/g, '').trim().replace(/ /g, '-').toLowerCase() ?? 'you-could-save-hundreds-get-a-free-quote-now';
  return mapPartnerTagToGA({
    name: 'rootInsurance',
    heading: `additional-resources::${headline}`,
    subhead: adSubHead
  });
}
export default partnerResourceHelper;